import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { BailModel } from "./bail.model";
import { BailService } from "./bail.service";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { BailDialogDeleteComponent } from './bail-dialog-delete.component';
import { BailDialogAssignExpenseComponent } from './bail-dialog-assignExpense.component';
import { ExpensesAdvancedPaymentConst } from '../const';
import { consts } from '../../../consts';
import { DummyComponent } from '../../../shared/dummy.component';
import { TableService } from '../../../shared/components/table/table.service';

@Component({
    selector: 'convfact-bail-list',
    templateUrl: './bail-list.component.html',
    styleUrls: ['./bail.component.css'],
    standalone: false
})

export class BailListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  dataResultTotals = null;

  constructor(
    private router: Router,
    private bailService: BailService,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    public snackBar: MatSnackBar,
    private tableService: TableService
  ) { }

  isDataAvailable: boolean = false;
  dataSource: BailModel[] = [];
  empty: boolean = false;
  ready: boolean = false;

  headerTable: any[] = ExpensesAdvancedPaymentConst.headerTable;

  create(): void {
    this.router.navigate(['/expense/advancepayment/bail/create']);
  }

  edit(uid: string): void {
    const payment = this.dataSource.find(f => f.uid == uid);
    if (payment.invoiceUid == consts.EMPTY_GUID) {
      this.router.navigate(['/expense/advancepayment/bail/edit/', uid]);
    } else {
      this.displayInfo("No es posible editar un adelanto que ya ha sido asignado.");
    }
  }

  delete(uid: string) {
    this.dialog.open(BailDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed()
      .subscribe(result =>
        this.dummy.redirectTo(this.router.url)
      );
  }

  assignExpense(uid: string) {
    const payment = this.dataSource.find(f => f.uid == uid);
    if (payment.invoiceUid == consts.EMPTY_GUID) {
      this.dialog.open(BailDialogAssignExpenseComponent, {
        data: {
          uid: uid,
          totalAmount: payment.total,
          proveedorUid: payment.providerUid
        }
      }).afterClosed()
        .subscribe(result =>
          this.dummy.redirectTo(this.router.url))
    } else {
      this.displayInfo("No es posible asignar un adelanto que ya ha sido asignado.");
    }
  }

  ngOnInit() {
    this.getList();
    this.getTotal();
  }

  getList() {
    this.bailService.getList(this.currentPage, this.itemsPerPage).then(
      data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        this.ready = true;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      });
  }

  pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  getTotal() {
    this.bailService.getTotal().then(
      data => {
        this.dataResultTotals = data;
      }
    );
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
